export default nodes => {
  return nodes.map(({ node }) => {
    return { ...node };
  });
};
